/* eslint-disable camelcase */
import React from 'react';
import './Modal.scss';
import {Fade, Modal} from '@mui/material';
import LogRocket from 'logrocket';


const _Modal = ({isOpen, onClose}) => {
  if (!isOpen) return null;

  const handleButtonClick = () => {
      LogRocket.log('User navigated to the new design');
      window.location.href = '/v2/';
  };
    const handleCloseButtonClick = () => {
        console.log('Chose current design');
        LogRocket.log('User chose to stay on the current design');
        onClose('close');
    };

  return (
    <Modal open={isOpen} onClose={() => {}} closeAfterTransition>
      <Fade in={isOpen}>

          <div className="modal-content">
              <p style={{fontSize: '13px', textAlign: 'end', marginBottom: '0px', marginRight: '16px', fontWeight: 'bold', color: 'red'}}>
                  Versión antigua disponible hasta el 04/02/2025
              </p>

              <button className="modal-close-button" onClick={handleCloseButtonClick}>
                  ✕
              </button>
              <div className='modal-title-3'>
                  <h2 className='h3'>¡Estrenamos nuevo diseño!</h2>
              </div>
              <div className='modal-body-1'>
                  <p className='body-1 '>
                      Actualizamos el diseño para ofrecerte una experiencia más intuitiva y moderna.
                      <br/>
                      Aprende a sacarle el máximo provecho con este breve manual de uso.
                  </p>
              </div>

              <div className='modal-subtitle-1' style={{marginBottom: '16px'}}>
                  <p className='subtitle-1 '>
                      Guía rápida de cómo usar la nueva página:
                  </p>
              </div>
              <iframe width="560" height="315" src="https://www.youtube.com/embed/w4sG4QAa89Y?si=azEwtsaCcmBCDY1T"
                      title="YouTube video player" frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

              <div className='modal-button'>
                  <button className='v2-button subtitle-1' onClick={handleButtonClick}>
                      Ir al nuevo diseño
                  </button>
              </div>

          </div>
      </Fade>
    </Modal>
  )
      ;
};

export default _Modal;
